import { useTranslation } from '@/lib/i18n';
import { StatusPill } from '@/components/ui';
import { resolvePledgeStatus } from '@/lib/domain';

export interface PledgeStatusPillProps {
  status: string | null | undefined;
  pledgeId?: string;
}

export const PledgeStatusPill = ({ status, pledgeId }: PledgeStatusPillProps) => {
  const { t } = useTranslation('funding');
  const meta = resolvePledgeStatus(status, pledgeId ? { pledgeId } : undefined);
  return (
    <StatusPill
      variant={meta.badge}
      displayStatus={status}
      label={t(meta.i18nKey, status ?? '')}
      testId="pledge-status-pill"
    />
  );
};
